import { useContext } from "react";
import styled from "styled-components";
import { Context } from "../../../context";

export const FAQWrapper = styled("div")(() => {
  const { isMenuOpen } = useContext(Context);
  return {
    position: "relative",
    top: isMenuOpen ? "var(--mobileNavLinks)" : "0",
    padding: "0 var(--pagePadding)",
    margin: "calc(var(--sectionMargin) * 2) auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& h2": {
      textAlign: "center",
    },
    "& .faq-item": {
      justifyContent: "center",
      display: "flex",
      flexDirection: "column",
      width: "60%",
      borderBottom: "1px solid #808080",
      "@media screen and (max-width: 768px)": {
        width: "100%",
      },
    },
    "& .faq-item-row": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center ",
      width: "100%",
      gap: "calc(var(--flex-gap)/4)",
      padding: "calc(var(--cardPadding)/2) 0",
      transition: "all 0.3s ease",
      "& .faq-question": {
        flexDirection: "column",
        flex: 1,
        marginBlock: 0,
      },
    },
    "& .faq-answer": {
      marginBlock: 0,
      color: "var(--color-text-light)",
      paddingBottom: "calc(var(--cardPadding)/2)",
      maxHeight: "1000px",
      overflow: "hidden",
      animation: "$slideDown 0.4s ease-out forwards",
      "@keyframes slideDown": {
        from: {
          maxHeight: "0",
          opacity: 0,
          marginBlock: 0,
        },
        to: {
          maxHeight: "1000px",
          opacity: 1,
          marginBlock: "1rem",
        },
      },
    },
    "@media screen and (max-width: 768px)": {
        width: "100%",
    }
  };
});
